//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import type { SubscriptionStatisticsModel } from './models/SubscriptionStatisticsModel';
import { Utilities } from './Utilities';

export class StatisticsClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        getStatistics: (): string => {
            let clientRequestUrl = '/api/v1/statistics';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    };

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Get subscription statistics
     * @return OK
     */
    async getStatistics(): Promise<SubscriptionStatisticsModel> {
        const clientRequestUrl = this.baseUrl + this.routes.getStatistics();

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<SubscriptionStatisticsModel>(_response, false, []);
    }
}
